import { PspContext } from "@/config/contexts";
import { Dispatch, SetStateAction, useContext } from "react";

type UsePageSwitcherParams = {
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
  totalPages: number | undefined;
};

export function usePageSwitcher({
  currentPage,
  setCurrentPage,
  totalPages,
}: UsePageSwitcherParams) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang } = useContext(PspContext);

  // -----------------------------------------------------------------------------
  // CALLBACK FUNCTIONS
  // -----------------------------------------------------------------------------
  function onPrevious() {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  }

  function onNext() {
    if (totalPages && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  }

  return { lang, onPrevious, onNext };
}
